export const agreementColumns = [
	{ columnHeader: "Agreement ID", sortKey: "agreementID", keys: [ "agreementId" ] },
	{ columnHeader: "Agreement Title", keys: [ "agreementTitle" ] },
	{ columnHeader: "Agreement Type", keys: [ "agreementType" ] },
	{ columnHeader: "Agreement Status", keys: [ "agreementStatus" ] },
	{ columnHeader: "Execution Date", keys: [ "executionDate" ] },
	{ columnHeader: "Principal Investigator", keys: [ "primaryInvestigators" ] },
	{ columnHeader: "Admin Unit", keys: [ "units" ] },
	{ columnHeader: "", keys: [ "actions" ] }
];